<!--
  As of 2020-05-26, this is a copy of the Events/Event.vue template.
  We can modify it as needed to make it work for Network Registrations.
-->
<template>
    <div :class="cssClasses">
        <div class="eventInformation networkInformation">
            <v-container class='pt-0'>
                <v-layout row wrap>
                    <v-flex sm7 class='information'>
                        <h4 v-if="extract('event.open')">Register for the</h4>
                        <h3 v-html="extract('event.content.body.title') || extract('event.name')"></h3>
                        <div class="event-description" v-html="extract('event.content.body.description')"></div>
                        <table class="event-sections" v-if="extract('event.content.body.sections')">
                            <tr v-for="(obj, num) in extract('event.content.body.sections')" v-bind:key="num">
                                <td class="rowLabel"><h4 class="section-title">{{ extract('event.content.body.sections.'+num+'.title') }}:</h4></td>
                                <td v-html="extract('event.content.body.sections.'+num+'.html')"></td>
                            </tr>
                        </table>
                        <div class="event-closing" v-if="extract('event.content.body.closing')" v-html="extract('event.content.body.closing')"></div>
                        <div>
                            <span class="capacity-notice" v-if="!loading && availableSlots < 1">The network is currently at capacity, but sign up below to be added to the wait list and we'll email you if a spot opens up.</span>
                        </div>
                    </v-flex>
                    <v-flex sm4 offset-sm1 class='callout'>
                        <!-- IF DEFAULT ASIDE -->
                        <div class='whiteBox pa-4 mb-4 hidden-xs-only' v-if="hasAside" >
                            <div v-if="hasAside">
                                <div v-if="defaultAside">
                                    <!-- <p><img src="@/assets/es/Summit_SideCallout.svg" style='max-height: 200px; max-width:100%' /></p> -->
                                    <p><v-img src='@/assets/es/Summit_01@2x.jpg' /></p>
                                    <p><v-img src='@/assets/es/Summit_02@2x.jpg' /></p>
                                </div>
                               <div v-else class="customAside">
                                <AmazeDynamicComponent v-bind:template="extract('event.content.aside.html')"></AmazeDynamicComponent>
                            </div>
                            </div>
                        </div>
                        <!-- END DEFAULT ASIDE -->
                        <div id="refund-dialog">
                            <v-dialog v-model="dialog" max-width="500px">
                            <v-btn slot="activator"
                                   color="primary"
                                   style="display: none;"
                                   id="refund-dialog-button"
                                   class="mb-4 mt-4 ml-0">
                                Learn more about RTI's refund and cancellation policy
                            </v-btn>
                            <v-card>
                                <v-card-title>
                                    <h3 class="headline">Refund and Cancellation Policy</h3>
                                </v-card-title>
                                <hr class="thick" >

                                <v-card-text>
                                    <v-layout wrap>
                                        <div class='pa-2 mb-2'>
                                            <p>The {{ event.name }} Cancellation and Refund Policy will be as follows to assure consistency and is applicable to this network.</p>
                                            <p>{{ event.name }} registration canceled online on or before {{ getFormattedDate(event.refund_expiry) }} is refundable if already paid, or not due if not already paid. In order for your cancellation to be received, email <a href="mailto:educationservices@rti.org ">educationservices@rti.org</a> no later than {{ getFormattedDate(event.refund_expiry) }}.</p>
                                        </div>
                                    </v-layout>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            color="blue darken-1"
                                            flat
                                            @click="dialog=false">Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <!-- BEGIN THE FORMATIONING -->
        <div class="registrationForm" v-if="!loading">
            <div class="text-xs-center" v-if="!extract('event.open')">
                <h4>Registration is closed for this network.</h4>
            </div>
            <v-form ref="regForm" v-model="valid" v-if="extract('event.open')">
                <v-container>
                    <v-layout row wrap>
                        <v-flex md6>
                            <h3>Registration <small>Required fields <span class='star'>*</span></small></h3>

                            <h5>District Information</h5>

                            <v-text-field v-model="districtName" required :rules="rules.district">
                                <template slot="label">District Name<span class='star'>*</span></template>
                            </v-text-field>

                            <div>
                                <h5>Contact Information</h5>
                                <p>Please enter registration information for yourself (the primary contact / person completing this form) and the superintendent.</p>

                                <h5>Primary Contact</h5>
                                <v-text-field v-model="registrant[0].name" required :rules="rules.name" >
                                    <template slot="label">
                                        Name<span class='star'>*</span>
                                    </template>
                                </v-text-field>
                                <AmazeEmailAddressInput v-model="registrant[0].email">
                                    <template slot="label">E-mail</template>
                                </AmazeEmailAddressInput>

                                <h5>Superintendent</h5>
                                <v-text-field v-model="registrant[1].name" required :rules="rules.name" >
                                  <template slot="label">
                                      Superintendent Name<span class='star'>*</span>
                                  </template>
                                </v-text-field>
                                <AmazeEmailAddressInput v-model="registrant[1].email">
                                  <template slot="label">Superintendent E-mail</template>
                                </AmazeEmailAddressInput>
                            </div>

                            <div v-if="membershipOptions" id="MembershipOptionsContainer">
                               <h5>Membership Option</h5>
                                <p>Please select from the options below.</p>

                                <v-radio-group v-model="membershipOption" required :rules="rules.option">
                                  <v-radio
                                          v-for="n in membershipOptions"
                                          :key="n.name"
                                          :label="n.description"
                                          :value="n.value"
                                          required
                                  >
                                  <template v-slot:label>
                                    <div class="radioLabel membershipOptionLabel">
                                      <p class="membershipOptionName">{{n.name}}</p>
                                      <p class="membershipOptionDescription" v-html="n.description"></p>
                                      </div>
                                  </template>
                                  </v-radio>
                                </v-radio-group>

                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 class="mt-20" >
                            <div class="submit-wrapper" v-if="registrants > 0" >
                                <div class="submit-success" v-if="this.submittedSuccessfully">
                                     <h5>Success!</h5>
                                    <p><strong>Thank you for registering for the <span v-html="extract('event.content.body.title') || extract('event.name')"></span>!</strong> You should receive a confirmation email shortly. If you do not receive an email, please contact <a :href="'mailto:'+contactAddress">{{ contactAddress }}</a>.</p>
                                </div>
                                <div class="submit-incomplete" v-else>
                                    <h5 v-if="terms || acknowledgement">Terms and Conditions</h5>
                                    <div v-if="terms || acknowledgement">
                                        <div id="netTermsWrapper">
                                          <AmazeTermsViewer :src="terms"></AmazeTermsViewer>
                                        </div>
                                        <div v-if="acknowledgement" v-html="acknowledgement" id="acknowledgement"></div>
                                        <div v-if="acknowledgement">
                                          <v-checkbox
                                            required
                                            :rules="rules.acknowledge"
                                            v-model="acknowledge"
                                            :disabled="acknowledge"
                                            :label="`I acknowledge that I have read and accept the terms and conditions.`"
                                          ></v-checkbox>
                                        </div>
                                    </div>
                                    <v-btn v-if="!submitted" class='ml-0' color="primary" @click="submitRegistration()">Submit Registration</v-btn>
                                    <v-progress-circular v-else indeterminate />
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </div>

        <!-- END THE FORMATIONING -->

    </div>
</template>
<style scoped lang="scss">

</style>
<script>
import AmazeTermsViewer from "@/components/Widgets/AmazeTermsViewer";
import registrationMixin from "@/mixins/registrationMixin.js";

export default {
  mixins: [registrationMixin],
  data() {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,
      acknowledge: false,

      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      schoolName: '',
      districtName: '',
      stateName: '',

      schoolAddress: {
        street: null,
        city: null,
        state: null,
        zip: null
      },

      billingSame: false,
      cachedBilling: null,
      billingAddress: {
        street: null,
        city: null,
        state: null,
        zip: null
      },

      membershipOption: null,

      roles: ['Principal', 'Lead Teacher', 'Lead Counselor', 'College Liaison', 'Other'],

      registrants: 2,
      numRegistrants: 2,
      registrant: [{
        name: '',
        email: null,
        role: 'Point of Contact'
      }, {
        name: '',
        email: null,
        role: 'Superintendent'
      }],
      submittedSuccessfully: false,
      rules: {
        name: [v => !!v || "Name is required."],
        email: [
          v => !!v || "Email is required.",
          v => /@/.test(v) || "Please enter a valid email."
        ],
        option: [v => !!v || 'Membership Option is required.'],
        role: [v => !!v || "Role is required."],
        school: [v => !!v || "School name is required."],
        district: [v => !!v || "District name is required."],
        state: [v => !!v || "State is required."],
        size: [v => !!v || "Team size is required."],
        acknowledge: [v => !!v || "Please accept the terms and conditions."]
      },
      event: {}
    };
  },
  watch: {
    billingSame: function(newVal, oldVal) {
      if (newVal) {
        this.cachedBilling = this.billingAddress;
        // Billing is same as school.
        this.billingAddress = this.schoolAddress;
      } else {
        if (this.cachedBilling) {
          this.billingAddress = this.cachedBilling;
        } else {
          this.billingAddress = this.defaultSchool;
        }
      }
    }
  },
  computed: {
    defaultSchool() {
      return {
        street: null,
        city: null,
        state: null,
        zip: null
      };
    },
    content() {
      // var defaults = {};
      return event.content ? event.content : false;
    },
    id() {
      return this.extract('event.id');
    },
    terms() {
      return this.extract('event.content.terms', false);
    },
    acknowledgement() {
      return this.extract('event.content.acknowledgement', false);
    },
    membershipOptions () {
      return this.extract('event.content.membershipOptions', false);
    },
    showWaiver() {
      // By default, we should be showing the waiver. However, if the waiver meta entry is set
      // to false, that indicates we should not show the waiver.
      return this.extract('event.content.meta.waiver', true);
    },
    hasAside() {
      var aside = this.extract('event.content.aside.custom');
      return aside !== null && typeof aside !== 'undefined';
    },
    defaultAside() {
      return !this.extract('event.content.aside.custom') || !this.extract('event.content.aside.html');
    },
    registrationIsSingle() {
      return false;
    },
    registrantSlots() {
      let slots = [];
      for (let i = 1; i <= this.maxRegistrants; i++) {
        if (i === 1) {
          slots.push({ text: i + " attendee", value: i });
        } else {
          slots.push({ text: i + " attendees", value: i });
        }
      }
      return slots;
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    loaded() {
      return !this.loading;
    },
    showSubmitPrompt() {
      return !this.submittedSuccessfully && this.registrants > 0;
    }
  },
  methods: {
    initializeSlots() {
      let backup = this.registrant;
      this.registrant = [];
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person];
        } else {
          this.registrant[person] = {
            name: '',
            email: null,
            role: null
          };
        }
      }
    },
    submitRegistration() {
      if (this.$refs.regForm.validate()) {
        this.submitted = true;
        // Registrant 1 (i.e. 0 index) must accept terms to submit,
        // so we're flagging the acceptanc here.
        this.registrant[0].terms = this.acknowledge;
        let data = {
          school: this.schoolName,
          district: this.districtName,
          state: this.schoolAddress.state,
          team_total: this.registrants,
          registration_event_id: this.extract('event.id'),
          registration_team_member: [this.registrant[0], this.registrant[1]],
          single_registration: false,
          extra_attributes: {

          }
        };

        this.$http.post('registrations', data).then(
          response => {
            this.submittedSuccessfully = true;
          },
          response => {
            this.submitted = false;
            this.$store.commit("updateMessage", {
              message: "There was a problem saving your registration. Please try again or contact support.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message: "Required fields are missing. Please review the form.",
          snackbar: true
        });
      }
    }
  },
  mounted() {
    this.$http.get('event/' + (this.$route.params.slug || this.$route.path.split('/').pop())).then((response) => {
      this.event = response.data.data[0];

      this.totalAttendees = this.extract('event.total_attendees') || 0;
      this.maxAttendees = this.extract('event.max_attendees') || 0;

      this.availableSlots = Math.max(0, this.maxAttendees - this.totalAttendees);

      this.maxRegistrants = this.extract('event.max_per_team');
      // If we need to limit registration to only accept the max number of slots, we can use the following logic:
      // Math.min(this.extract('event.max_per_team'), (this.maxAttendees - this.totalAttendees));

      var fields = this.extract('event.content.form.fields');

      if (fields) {
        for (const key in fields) {
          var field = fields[key];
          // Set defaults.
          if (field.hasOwnProperty('default')) {
            this[key] = field.default;
          }
          // Set values.
          if (field.hasOwnProperty('values')) {
            this[key] = field.values;
          }
        }
      }

      this.loading = false;
    // eslint-disable-next-line handle-callback-err
    }, error => {
      this.$router.push('/404')
    });
  },
  components: {
    AmazeTermsViewer
  }
}
</script>
